import { motion } from 'framer-motion';
import { useInViewScroll, StackedContent, NascarLogo } from 'ui';

interface NascarHeroProps {
  bgimg?: object;
  content?: object;
  nascarLogo?: boolean;
}

export const NascarHero = ({
  bgimg,
  content,
  nascarLogo = false
}: NascarHeroProps) => {
 
  const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100vh', 'end 0vh']);

  return (
    <motion.section ref={ref} className="relative z-40 flex w-full justify-center bg-white" data-testid={'nascar-section'}>
      <div className="w-full h-full lg:h-[90vh] flex flex-col-reverse lg:flex-row">
        {/* Stacked content */}
        <div className="content-wrapper flex flex-col items-center justify-center w-full lg:w-1/2">
            {nascarLogo &&
              <NascarLogo className="hidden lg:flex p-6"/>
            }
            <StackedContent
            minHeight
            space
            center
            content={content}
            />
        </div>
        {/* Image */}
        <div 
          className="w-full lg:w-1/2 h-full min-h-[400px]"
          style={{
            backgroundImage: "url('https://comcast-smart-solutions.directus.app/assets/68506111-3d2d-4f0d-891e-a9d9f98673f5')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat'
          }}
        >
        </div>
        {/* NASCAR Logo for small screens */}
        {nascarLogo &&
          <NascarLogo className="flex lg:hidden p-6 min-[250px]:p-10"/>
        }
      </div>
    </motion.section>
  );
};
